import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/shared/PageHero";
import { Stagger, StaggerItem } from "@/components/shared/Reveal";
import { CTABand } from "@/components/shared/CTABand";
import { INDUSTRIES } from "@/data/industries";
import { useSEO } from "@/lib/seo";

export default function Industries() {
  useSEO({
    title: "Industries We Serve",
    description:
      "Vikas Rolls supplies engineered rolls to steel, paper, packaging, leather, glass, textile, wood, rexine, food & beverage, printing and conveyor applications.",
  });

  return (
    <>
      <PageHero
        chapter="I"
        label="Industries Served"
        title="Rolls for Every Line That Runs on Them"
        sub="Eleven industry sectors, hundreds of roll positions. Explore each industry to see the specific rolls we manufacture, cover and refurbish."
        crumbs={[{ label: "Industries" }]}
      />
      <section className="bg-ink py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
            {INDUSTRIES.map((ind) => (
              <StaggerItem key={ind.slug} className="bg-ink">
                <Link
                  to={`/industries/${ind.slug}`}
                  data-testid={`industry-card-${ind.slug}`}
                  className="group block bg-ink-2 hover:bg-ink-3 h-full"
                >
                  <div className="relative overflow-hidden h-36">
                    <img src={ind.images[0]} alt={`${ind.name} industry`} loading="lazy" className="img-industrial absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink-2 via-ink/30 to-transparent" />
                    <span className="absolute top-3 left-3 font-mono-tech text-[10px] bg-ink/80 border border-line text-amber-brand px-2.5 py-1 tracking-[0.2em]">{ind.index}</span>
                  </div>
                  <div className="p-6">
                    <h2 className="flex items-center justify-between font-display font-bold text-xl md:text-2xl text-steel-light group-hover:text-amber-brand mb-2">
                      {ind.name}
                      <ArrowUpRight size={18} className="text-line group-hover:text-amber-brand transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </h2>
                    <p className="text-sm text-steel leading-relaxed mb-4">{ind.short}</p>
                    <p className="font-mono-tech text-[10px] uppercase tracking-[0.15em] text-steel/60">
                      {ind.groups.reduce((n, g) => n + g.rolls.length, 0)} roll types
                    </p>
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
      <CTABand />
    </>
  );
}
